import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import GoalConfigItem from "./GoalConfigItem";
import ErrorBoundary from "../common/ErrorBoundary";
import { saveGoal } from "../../../store/slices/admin/goals";
import moment from "moment";

const CreateGoal = () => {
	const now = useMemo(() => {
		return moment().utc();
	}, []);
	const dispatch = useDispatch();
	const isUpdating = useSelector((state: any) => state.goals.isUpdating);
	const [renameActive, setRenameActive] = useState(false);
	const [data, setData] = useState({
		title: "Example goal",
		metricType: "pageviews",
		target: "",
		startDate: now.format("YYYY-MM-DD"),
		endDate: now.clone().add(1, "month").endOf("month").format("YYYY-MM-DD"),
		startTime: now.clone().startOf("hour").format("HH:mm"),
		endTime: "23:00",
		storyType: "all",
		recurrencyType: "onetime",
		sections: [],
		conversions: [],
		displayTimeleft: true,
		dailyRecurDays: { mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true },
		weeklyStartDay: "mon",
		weeklyEndDay: "sun",
		monthlyStartDay: 1,
		monthlyEndDay: 31,
		monthlyWhole: true,
		neverending: true,
		chartType: "donut",
		lineChartAutoRotate: true,
	});
	const brandData = useSelector((state: any) => state.authenticateuser.data);
	const isLoadingBradData = useSelector((state: any) => state.authenticateuser.isLoading);
	
	useEffect(() => {
		// After loading brand data update default start & end date times based on client's timezone
		if (!isLoadingBradData && brandData) {
			if (brandData?.domainSettings?.timezone) {
				const currentTzDateTime = moment().tz(brandData.domainSettings.timezone);
			
				setData((d) => ({ 
					...d, 
					startDate: currentTzDateTime.format("YYYY-MM-DD"),
					endDate: currentTzDateTime.clone().add(1, "month").endOf("month").format("YYYY-MM-DD"),
					startTime: currentTzDateTime.clone().startOf("hour").format("HH:mm")
				}));
			}
		}
	}, [isLoadingBradData, brandData]);

	const toggleRenameField = () => {
		setRenameActive((a) => !a);
	};

	const changeName = (e: any) => {
		let tc = { ...data };
		tc.title = e.target.value;
		setData(tc);
	};

	const updateData = (key: any, value: any) => {
		setData((d) => ({ ...d, [key]: value }));
	};

	const handleSaveGoal = () => {
		const d: any = { ...data };
		if (d.recurrencyType === "onetime") {
			delete d.neverending;
		}
		if (d.recurrencyType === "daily") {
			d.recurrencyValue = Object.entries(data.dailyRecurDays)
				.filter(([day, include]) => include)
				.map(([day]) => day)
				.join(",");
		}
		if (d.recurrencyType === "weekly") {
			d.startDay = d.weeklyStartDay;
			d.endDay = d.weeklyEndDay;
		}
		if (d.recurrencyType === "monthly") {
			if (d.monthlyWhole) {
				d.startDay = 1;
				d.endDay = 31;
			} else {
				d.startDay = d.monthlyStartDay;
				d.endDay = d.monthlyEndDay;
			}
		}

		// payload cleanup
		d.startTime += ":00";
		d.endTime += ":00";
		delete d.dailyRecurDays;
		delete d.weeklyStartDay;
		delete d.weeklyEndDay;
		delete d.monthlyStartDay;
		delete d.monthlyEndDay;
		delete d.monthlyWhole;
		if (d.neverending) delete d.endDate;
		delete d.neverending;
		if (d.chartType !== "line") delete d.lineChartAutoRotate;

		dispatch(saveGoal(d));
	};

	return (
		<div className="container create-dashboard">
			<div className="row">
				<div className="col-md-12">
					<div className="create-dashboard__header">
						{renameActive ? (
							<>
								<input type="text" className="form-control" value={data.title} onChange={changeName} />
								<button className="btn btn-outline-primary" onClick={toggleRenameField}>
									Save
								</button>
							</>
						) : (
							<>
								<h2>{data.title}</h2>
								<button className="btn btn-outline-primary" onClick={toggleRenameField}>
									Rename
								</button>
							</>
						)}
						<div className="ml-auto">
							<button className="btn btn-primary" onClick={handleSaveGoal} disabled={isUpdating}>
								Save Goal
							</button>
						</div>
					</div>
				</div>
				<div className="col-md-12">
					<div className="config-tab d-block">
						<div className="configuration mt-5">
							<h2 className="mb-4">Goal Configuration</h2>

							<div className="config-list">
								<ErrorBoundary>
									<GoalConfigItem
										id={0}
										isEdit={false}
										data={data}
										updateData={updateData}
										timezone={brandData?.domainSettings?.timezone}
									/>
								</ErrorBoundary>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateGoal;
